export default __webpack_public_path__ + "img/4be09c1f7cba7ecd0c70baacb78a60c4.svg";